<template>
  <MainLayout>
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-12">

          <nav class="navbar navbar-toggleable navbar-light">
            <ul class="nav navbar-nav">
              <li class="nav-item" v-bind:class="customCardsTabBindings">
                <Tooltip
                  position="bottom"
                  v-bind:show="showTooltip"
                  v-on:tooltip-closed="onTooltipClosed"
                >
                  <router-link to="/library/custom-cards" class="nav-link typography--body-3">
                    커뮤니티 자료
                  </router-link>

                  <div slot="tooltip-body">
                    <div class="typography--body-3 typography--color-secondary"
                         v-html="$t('common.tooltip.try_custom_card')">
                    </div>
                  </div>
                </Tooltip>
              </li>
              <li class="nav-item" :class="schoolCardsTabBindings">
                <router-link to="/library/school-cards" class="nav-link typography--body-3">
                  소속 기관 자료
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div class="container mw-960" slot="layout-body">
      <div class="row browse-filter-row">
        <div class="col-12 col-lg-7 ml-0 mr-0">
          <div class="row box">
            <div class="col-sm-3 divider">
              <b-dropdown
                class="mnv-dropdown grade-select"
                :text="getTranslatedName(gradeMap[libraryFilters.grade_id])"
              >
                <b-dropdown-item v-on:click="selectGrade('0', '0')">
                  {{ $t('common.selects.all_grades') }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="(value, key) in gradeList"
                  v-on:click="selectGrade(value.id, value.school_year)"
                  v-bind:key="key"
                >
                  {{ getTranslatedName(gradeMap[value.id]) }}
                </b-dropdown-item>
                <b-dropdown-item v-on:click="selectGrade('null', 'null')">
                  {{ $t('common.selects.others') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="col-sm-3 divider">
              <b-dropdown
                id="subject-dropdown"
                class="mnv-dropdown subject-select"
                v-bind:text="getTranslatedName(subjectMap[libraryFilters.subject_id])"
              >
                <b-dropdown-item v-on:click="selectSubject('0')">
                  {{ $t('common.selects.all_subjects') }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="(value, key) in gradeSubjects"
                  v-on:click="selectSubject(value.id)"
                  v-bind:key="key"
                >
                  {{ getTranslatedName(subjectMap[value.id]) }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- Units -->
            <div class="col-sm-6">
              <b-dropdown v-bind:text="getUnitLabel(units[libraryFilters.unit_id]) || $t('common.browse_filters.all_chapters')" class="mnv-dropdown chapter-select" id="unit-dropdown">
                <b-dropdown-item v-on:click="selectUnit('0')">
                  {{ $t('common.browse_filters.all_chapters') }}
                </b-dropdown-item>

                <b-dropdown-item v-for="unit in currentUnitList"
                                 v-on:click="selectUnit(unit.id)"
                                 v-bind:key="unit.id">
                  {{ getUnitLabel(unit) }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- Core Concepts -->
            <!-- <div class="col-sm-6" v-show="getSchoolYear(gradeMap[libraryFilters.grade_id]) >= 7">
              <b-dropdown v-bind:text="getDetailedCoreConceptLabel(coreConcepts[libraryFilters.core_concept_id]) || $t('common.browse_filters.all_core_concepts')" class="mnv-dropdown core-concept-select" id="core-concept-dropdown">
                <b-dropdown-item v-on:click="selectCoreConcept('0')">
                  {{ $t('common.browse_filters.all_core_concepts') }}
                </b-dropdown-item>

                <b-dropdown-item v-for="coreConcept in currentCoreConceptList"
                                 v-on:click="selectCoreConcept(coreConcept.id)"
                                 v-bind:key="coreConcept.id"
                                 v-bind:title="`${$t('card_details.card_meta.learning_elements')}: ${coreConcept.description}`">
                  {{ getDetailedCoreConceptLabel(coreConcept) }}
                </b-dropdown-item>
              </b-dropdown>
            </div> -->
          </div>
        </div>
        <div class="col-12 col-lg-5 pl-12">
          <SearchInput v-bind:model-value="libraryFilters.search_keywords" v-on:input="applySearchKeywords"></SearchInput>
        </div>
      </div>

      <div class="row browse-filter-row">
        <div class="col-sm-8">

          <Radio v-on:change="selectMediaType" v-bind:model-value="libraryFilters.media_type" check-value="all" id="media-type-all">
            <span slot="label">{{ $t('common.browse_filters.media_type.all') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="libraryFilters.media_type" check-value="image" id="media-type-image">
            <span slot="label">{{ $t('common.browse_filters.media_type.image') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="libraryFilters.media_type" check-value="video" id="media-type-video">
            <span slot="label">{{ $t('common.browse_filters.media_type.video') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="libraryFilters.media_type" check-value="audio" id="media-type-audio">
            <span slot="label">{{ $t('common.browse_filters.media_type.audio') }}</span>
          </Radio>

        </div>

        <div class="col-sm-4">
          <ul class="nav justify-content-end order-by-btns">
            <li class="nav-item">
              <a class="nav-link typography--color-secondary"
                 v-bind:class="{ active: libraryFilters.order_by === 'updated_at' }"
                 v-on:click="selectOrderBy('updated_at')">{{ $t('common.browse_filters.order_by.recency') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link typography--color-secondary"
                 v-bind:class="{ active: libraryFilters.order_by === 'popularity' }"
                 v-on:click="selectOrderBy('popularity')">{{ $t('common.browse_filters.order_by.popularity') }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row" v-if="loading">
        <div class="col-sm-6 col-md-4 col-lg-3" v-for="n in 4" v-bind:key="n">
          <div class="card-row">
            <DummyCard></DummyCard>
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-sm-6 col-md-4 col-lg-3">
          <div class="card-row">
            <AdCard/>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-lg-3" v-for="card in currentCardList" v-bind:key="card.id">
          <div class="card-row">
            <LibraryCard v-bind:card="card"></LibraryCard>
          </div>
        </div>

        <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
          <div slot="spinner">
            <LoadingBounce></LoadingBounce>
            <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
          </div>

          <div slot="no-more" class="col-12 text-center mb-5 pb-5">
            <div class="empty-list-text typography--body-2 typography--color-disabled pt-4">
              {{
                this.libraryFilters.search_keywords
                  ? $t('library.no_search_cards', { keyword: this.libraryFilters.search_keywords })
                  : $t('library.no_cards')
              }}
            </div>
          </div>
        </InfiniteLoading>
      </div>
    </div>

    <div slot="modal-area">
      <b-modal id="no-class-to-assign-alert"
               class="basic-modal no-header-modal hide-cancel-btn"
               v-bind:hide-header="true"
               v-bind:ok-title="$t('common.confirm')">
        <div v-html="$t('common.modal.no_class_to_assign_alert.message')"></div>
      </b-modal>
      <CustomModal
        v-if="isSchoolInfoModal && isEmptySchoolInfo && isSchoolCardTab"
        id="school-info-modal"
        class="basic-modal no-header-modal hide-cancel-btn"
        :hide-header="true"
        :ok-title="$t('common.confirm')"
        @ok="handelSchoolInfoConfirmClick"
      >
        <div class="typography--color-primary">
          {{ $t('errors.empty_school_info') }}
        </div>
      </CustomModal>
        <CustomModal
          v-if="isNoticeModal"
          id="evaluation-service-gone-modal"
          class="basic-modal hide-cancel-btn"
          :title="'이제 새로운 클래스에서 러닝(학습자료실)을 사용해보세요!'"
          :ok-title="$t('common.confirm')"
          @ok="handleNoticeModalConfirmClick"
        >
        <div>
          새로운 클래스에서 '자료실 과제' 만들기를 누르면 러닝(학습자료실)의 모든 자료를 한 번에 조회하고 첨부할 수 있어요.<br />
          러닝(학습자료실)에서 기존 클래스로 '내보내기'하는 기능 종료 기한을 연장하였습니다.<br />
          자세한 내용은 <a href=" https://support.classting.com/hc/ko/articles/4422617956377-%EB%9F%AC%EB%8B%9D-%ED%95%99%EC%8A%B5%EC%9E%90%EB%A3%8C%EC%8B%A4-%EC%9D%BC%EB%B6%80-%EA%B8%B0%EB%8A%A5-%EC%A2%85%EB%A3%8C-%EB%B0%8F-%EC%97%85%EB%8D%B0%EC%9D%B4%ED%8A%B8-%EC%95%88%EB%82%B4-2022-02-24-" target="_blank">공지사항</a>을 확인해주세요.
        </div>
      </CustomModal>
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, debounce, isNil } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';
  import labels from '@/mixins/labels';
  import { FEATURED_PUBLISHER_ID, CLASSTING_URL } from '@/config';
  import LibraryCard from '../components/LibraryCard';
  import AdCard from '../components/AdCard';

  export default {
    name: 'library',

    components: {
      InfiniteLoading,
      LibraryCard,
      AdCard,
    },

    mixins: [
      labels,
    ],

    data() {
      return {
        loading: false,
        isSchoolInfoModal: false,
        isNoticeModal: false,
      };
    },

    computed: {
      ...mapGetters([
        'trimmedLibraryFilters',
        'checkedTutorials',
        'coreConceptList',
        'customCardList',
        'libraryFilters',
        'getRouteQuery',
        'coreConcepts',
        'subjectMap',
        'subjectIds',
        'gradeMap',
        'gradeIds',
        'unitList',
        'units',
        'currentUser',
        'subjectList',
        'gradeList',
        'gradeSubjects',
      ]),

      showTooltip() {
        if (!isEmpty(this.checkedTutorials) &&
            this.checkedTutorials.welcome &&
            !this.checkedTutorials.tryCustomCard) {
          return true;
        }

        return false;
      },

      isFeaturedCardTab() {
        return this.$route.params.card_type === 'featured-cards';
      },

      isSchoolCardTab() {
        return this.$route.params.card_type === 'school-cards';
      },

      selectedSubjectGrade() {
        return `${this.libraryFilters.subject_id}&${this.libraryFilters.grade_id}`;
      },

      currentUnitList() {
        return this.unitList.filter(unit => (
          unit.subject_id === parseInt(this.libraryFilters.subject_id, 10) &&
          // unit.grade_id === parseInt(this.libraryFilters.grade_id, 10) &&
          unit.name !== 'NO NAME YET'
        ));
      },

      currentCoreConceptList() {
        return this.coreConceptList.filter(coreConcept => (
          coreConcept.subject_id === parseInt(this.libraryFilters.subject_id, 10) &&
          coreConcept.grade_id === parseInt(this.libraryFilters.grade_id, 10)
        ));
      },

      currentCardList() {
        return this.customCardList;
      },

      customCardsTabBindings() {
        return {
          active: !this.isFeaturedCardTab && !this.isSchoolCardTab,
        };
      },

      featuredCardsTabBindings() {
        return {
          active: this.isFeaturedCardTab,
        };
      },

      schoolCardsTabBindings() {
        return {
          active: this.isSchoolCardTab,
        };
      },

      isEmptySchoolInfo() {
        if (isEmpty(this.currentUser)) return false;
        return isEmpty(this.currentUser.school_id);
      },
    },

    watch: {
      $route(state) {
        this.loading = true;

        if (state.params.card_type === 'featured-cards') {
          return this.setLibrartFilter({ property: 'offset', value: 0 })
            .then(() => (
              this.setLibrartFilter({ property: 'publisher_id', value: FEATURED_PUBLISHER_ID })
            ))
            .then(() => this.setLibrartFilter({ property: 'school_id', value: '' }))
            .then(() => (
              Promise.all([
                this.fetchCustomCards(this.trimmedLibraryFilters),
                this.fetchAdvertisement(),
              ])
            ))
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              console.error('err while fetching custom cards in library view:', err);
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }

        if (state.params.card_type === 'custom-cards') {
          // custom cards
          return this.setLibrartFilter({ property: 'offset', value: 0 })
            .then(() => (
              this.setLibrartFilter({ property: 'publisher_id', value: '0' })
            ))
            .then(() => this.setLibrartFilter({ property: 'school_id', value: '' }))
            .then(() => (
              Promise.all([
                this.fetchCustomCards(this.trimmedLibraryFilters),
                this.fetchAdvertisement(),
              ])
            ))
            .then(() => (
              this.setTutorialAsChecked('tryCustomCard')
            ))
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              console.error('err while fetching custom cards in library view:', err);
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }

        if (state.params.card_type === 'school-cards') {
          if (this.isEmptySchoolInfo) {
            this.isSchoolInfoModal = true;
            return true;
          }
          // custom cards
          return this.setLibrartFilter({ property: 'offset', value: 0 })
            .then(() => (
              this.setLibrartFilter({ property: 'publisher_id', value: '0' })
            ))
            .then(() => this.setLibrartFilter({ property: 'school_id', value: this.currentUser.school_id }))
            .then(() => (
              Promise.all([
                this.fetchCustomCards(this.trimmedLibraryFilters),
                this.fetchAdvertisement(),
              ])
            ))
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              console.error('err while fetching custom cards in library view:', err);
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }

        return true;
      },

      gradeSubjects(state) {
        if (isEmpty(state)) {
          document.getElementById('subject-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('subject-dropdown').firstElementChild.disabled = false;
        }
      },

      currentCoreConceptList(state) {
        if (isEmpty(state)) {
          document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
        }
      },

      currentUnitList(state) {
        if (isEmpty(state)) {
          document.getElementById('unit-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('unit-dropdown').firstElementChild.disabled = false;
        }
      },

      selectedSubjectGrade(state) {
        if (state.match(/^[0-9]+&0$/) || state.match(/^0&[0-9]+$/)) {
          return null;
        }

        if (!isNil(state.match(/[0-9]+&[0-9]+/))) {
          // if (this.getSchoolYear(this.gradeMap[this.libraryFilters.grade_id]) > 6) {
          //   if (isEmpty(this.currentCoreConceptList)) {
          //     return this.fetchCoreConcepts({
          //       subject_id: this.libraryFilters.subject_id,
          //       grade_id: this.libraryFilters.grade_id,
          //     });
          //   }

          //   return null;
          // }

          return this.fetchUnits({
            subject_id: this.libraryFilters.subject_id,
            grade_id: this.libraryFilters.grade_id,
          });
        }

        return null;
      },
    },

    methods: {
      ...mapActions([
        'setTutorialAsChecked',
        'fetchCoreConcepts',
        'setLibrartFilter',
        'fetchCustomCards',
        'fetchUnits',
        'fetchGradeSubjects',
        'resetGradeSubjects',
        'fetchAdvertisement',
      ]),

      onTooltipClosed() {
        this.setTutorialAsChecked('tryCustomCard');
      },

      onInfinite() {
        this.setLibrartFilter({ property: 'offset', value: this.libraryFilters.offset + 20 })
          .then(() => {
            if (this.isFeaturedCardTab) {
              return this.setLibrartFilter({ property: 'publisher_id', value: FEATURED_PUBLISHER_ID })
                .then(() => (
                  this.fetchCustomCards(this.trimmedLibraryFilters)
                ));
            }

            return this.fetchCustomCards(this.trimmedLibraryFilters);
          })
          .then((cardList) => {
            if (this.$refs.infiniteLoading) {
              this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

              if (cardList.length === 0) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              }
            }
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      selectSubject(subjectId) {
        if (this.libraryFilters.subject_id !== subjectId) {
          this.setLibrartFilter({ property: 'subject_id', value: subjectId })
            .then(() => (
              this.setLibrartFilter({ property: 'core_concept_id', value: '0' })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'unit_id', value: '0' })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchCustomCards(this.trimmedLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectGrade(gradeId, schoolYear) {
        if (this.libraryFilters.grade_id !== gradeId) {
          this.fetchGradeSubjects({ grade: schoolYear })
            .then(() => (
              this.setLibrartFilter({ property: 'school_year', value: schoolYear })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'grade_id', value: gradeId })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'subject_id', value: '0' })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'core_concept_id', value: '0' })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'unit_id', value: '0' })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;
              return this.fetchCustomCards(this.trimmedLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectCoreConcept(coreConceptId) {
        if (this.libraryFilters.core_concept_id !== coreConceptId) {
          this.setLibrartFilter({ property: 'core_concept_id', value: coreConceptId })
            .then(() => (
              this.setLibrartFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;
              return this.fetchCustomCards(this.trimmedLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectUnit(unitId) {
        if (this.libraryFilters.unit_id !== unitId) {
          this.setLibrartFilter({ property: 'unit_id', value: unitId })
            .then(() => (
              this.setLibrartFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;
              return this.fetchCustomCards(this.trimmedLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectMediaType(mediaType) {
        this.setLibrartFilter({ property: 'media_type', value: mediaType })
          .then(() => (
            this.setLibrartFilter({ property: 'offset', value: 0 })
          ))
          .then(() => {
            this.loading = true;
            return this.fetchCustomCards(this.trimmedLibraryFilters);
          })
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      selectOrderBy(orderByParam) {
        if (this.libraryFilters.order_by !== orderByParam) {
          this.setLibrartFilter({ property: 'order_by', value: orderByParam })
            .then(() => (
              this.setLibrartFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;
              return this.fetchCustomCards(this.trimmedLibraryFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      // eslint-disable-next-line func-names
      fetchWithSearchKeywords: debounce(function () {
        this.loading = true;
        this.fetchCustomCards(this.trimmedLibraryFilters)
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      }, 500),

      applySearchKeywords(inputText) {
        if (this.libraryFilters.search_keywords !== inputText) {
          this.setLibrartFilter({ property: 'search_keywords', value: inputText })
            .then(() => (
              this.setLibrartFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.fetchWithSearchKeywords();
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      fetchInitialData() {
        return Promise.resolve()
          .then(() => {
            if (this.isFeaturedCardTab) {
              return this.setLibrartFilter({ property: 'publisher_id', value: FEATURED_PUBLISHER_ID })
                .then(() => (
                  this.fetchCustomCards(this.trimmedLibraryFilters)
                ));
            }

            return this.fetchCustomCards(this.trimmedLibraryFilters);
          })
          .then(() => {
            this.loading = false;
          })
          .then(() => {
            if (!isEmpty(this.checkedTutorials) && !this.checkedTutorials.welcome) {
              this.$root.$emit('show::modal', 'welcome-message-modal');
            }
          })
          .catch((err) => {
            console.error('err while fetching store cards in library view:', err);
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      handelSchoolInfoConfirmClick() {
        window.open(`${CLASSTING_URL}/settings/personal_info`);
        this.isSchoolInfoModal = false;
        return this.$router.push('/library/custom-cards');
      },

      handleNoticeModalConfirmClick() {
        this.isNoticeModal = false;
      },
    },

    mounted() {
      if (isEmpty(this.gradeSubjects)) {
        document.getElementById('subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('subject-dropdown').firstElementChild.disabled = false;
      }

      if (isEmpty(this.coreConcepts)) {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
      }

      if (isEmpty(this.units)) {
        document.getElementById('unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('unit-dropdown').firstElementChild.disabled = false;
      }
    },

    created() {
      if (this.customCardList.length === 0) {
        this.loading = true;

        if (this.getRouteQuery.subject_id &&
            this.getRouteQuery.grade_id &&
            this.getRouteQuery.unit_id) {
          this.setLibrartFilter({ property: 'offset', value: 0 })
            .then(() => (
              this.setLibrartFilter({ property: 'subject_id', value: this.getRouteQuery.subject_id })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'grade_id', value: this.getRouteQuery.grade_id })
            ))
            .then(() => (
              this.setLibrartFilter({ property: 'unit_id', value: this.getRouteQuery.unit_id })
            ))
            .then(() => (
              this.fetchInitialData()
            ));
        } else {
          Promise.resolve()
            .then(() => (
              this.setLibrartFilter({ property: 'grade_id', value: this.currentUser.grade_id })
            ))
            .then(() => (
              this.fetchGradeSubjects({ grade: this.currentUser.grade_id })
            ))
            .then(() => (
              this.fetchInitialData()
            ));
        }
      } else if (this.getRouteQuery.subject_id &&
                 this.getRouteQuery.grade_id &&
                 this.getRouteQuery.unit_id) {
        this.loading = true;

        this.setLibrartFilter({ property: 'offset', value: 0 })
          .then(() => (
            this.setLibrartFilter({ property: 'subject_id', value: this.getRouteQuery.subject_id })
          ))
          .then(() => (
            this.setLibrartFilter({ property: 'grade_id', value: this.getRouteQuery.grade_id })
          ))
          .then(() => (
            this.setLibrartFilter({ property: 'unit_id', value: this.getRouteQuery.unit_id })
          ))
          .then(() => (
            this.fetchInitialData()
          ));
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/library/views/Library.vue